import React from 'react';
import './BetModals.css';

const GenerateOddsModal = ({
  isOpen,
  onClose,
  onConfirm,
  pricingOption,
  setPricingOption
}) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ borderRadius: '16px', padding: '24px', maxWidth: '400px' }}>
        <div className="card-title-sm" style={{ fontSize: '1.1rem', marginBottom: '24px', textAlign: 'center' }}>Generate Market</div>
        <div className="modal-body" style={{ marginBottom: '24px' }}>
          <label className="input-label-sm">Pricing Spread</label>
          <select className="premium-input" value={pricingOption} onChange={(e) => setPricingOption(e.target.value)}>
            <option value="">-- Select Option --</option>
            <option value="standard">Standard (No bias)</option>
            <option value="generous">Generous (+10%)</option>
            <option value="tight">Tight (-10%)</option>
          </select>
          <p style={{fontSize: '11px', color: '#94a3b8', marginTop: '8px'}}>
            Probabilities will be calculated based on historical player performance and society average.
          </p>
        </div>
        <div className="modal-actions" style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          <button className="btn-primary-bet" onClick={onConfirm}>Generate Now</button>
          <button className="btn-secondary-bet" onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default GenerateOddsModal;
